export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Bookmark-Gray-5ad3fd19539625773fc729db7fcc66dd.svg";